import React from 'react'
import classNames from 'classnames'

import Badge from 'components/Badge'
import Currency from 'components/Currency'
import UserPhoto from 'components/UserPhoto'
import LinkButtonBase from 'components/LinkButtonBase'

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { withStyles, createStyles, WithStyles, Theme } from '@material-ui/core/styles'

import { IUser } from 'protos'
import { Omit } from 'types'

export interface Props extends Omit<React.ComponentProps<typeof LinkButtonBase>, 'classes' | 'to'> {
  avatarUrl?: IUser['photoUrl'],
  badgeContent?: React.ReactNode,
  balance?: IUser['balance'],
  className?: string,
  userName?: IUser['name'],
}

const styles = (theme: Theme) => createStyles({
  button: {
    padding: 7,
    backgroundColor: 'rgba(0, 0, 0, .4)',
    borderRadius: 4,
  },
  small: {
    width: 20,
    height: 20,
  },
  grey: {
    color: theme.palette.grey[400],
  },
  bolder: {
    fontWeight: 500,
  },
})

type InjectedProps = Props & WithStyles<typeof styles>

const AccountInfo: React.SFC<InjectedProps> = ({
  avatarUrl,
  badgeContent,
  balance,
  className,
  classes,
  userName,
  ...props
}) => {
  return (
    <LinkButtonBase
      {...props}
      to="/store"
      color="accent"
      className={classNames(className, classes.button)}
    >
      <Grid container>
        <Grid item xs={12}>
          <Grid direction="row" wrap="nowrap" spacing={1} container>
            <Grid item>
              {
                badgeContent
                  ? (
                    <Badge badgeContent={badgeContent} color="primary">
                      <UserPhoto className={classes.small} src={avatarUrl || ''} />
                    </Badge>
                  )
                  : (
                    <UserPhoto className={classes.small} src={avatarUrl || ''} />
                  )
              }
            </Grid>
            <Grid item>
              <Grid direction="column" alignItems="flex-end" container>
                <Grid item>
                  <Typography className={classNames(classes.grey, classes.bolder)} variant="h1" noWrap>
                    {userName}
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.bolder} color="primary" variant="h1">
                    <Currency
                      value={balance && balance[0].value}
                      currency={balance && balance[0].currency}
                    />
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </LinkButtonBase>
  )
}

AccountInfo.defaultProps = {
  avatarUrl: 'http://i.pravatar.cc/20',
  userName: '-',
  balance: [{ value: 0 }],
}

export default withStyles(styles)(AccountInfo)
